module.exports = __webpack_public_path__ + "img/1576157840.eb92ac1c.jpg";